import styled from 'styled-components';

export const Paragraph = styled.div`
  margin-bottom: 20px;
`;

export const TextLine = styled.div`
  display: block;
  margin-bottom: 5px;
`;
